import { useState, useEffect, useCallback } from "react";
import { fetchAuthMe } from "../../../api/requests/auth-requests";

export const useProfileUser = () => {
    const [me, setMe] = useState(null);
    const [roles, setRoles] = useState([]);
    const [loadingUser, setLoadingUser] = useState(true);

    const fetchUser = useCallback(async () => {

        try {
            setLoadingUser(true);

            const res = await fetchAuthMe();

            const json = await res.json();

            if (res.ok && json?.data) {
                setMe(json.data);
                setRoles(json.data.roles || []);
            } else {
                setMe(null);
                setRoles([]);
            }
        } catch (e) {
            console.error("Auth error:", e);
            setMe(null);
            setRoles([]);
        } finally {
            setLoadingUser(false);
        }
    }, []);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    return { me, roles, loadingUser, refetchMe: fetchUser };
};